import {
  type DatabaseAction,
  databaseActions,
  type DatabaseState,
  initialDatabaseState
} from '../context';

const computeCanWrite = (state: DatabaseState): boolean =>
  state.isTabActive &&
  !!state.db &&
  !state.disabled &&
  !state.pendingMigrations;

export const databaseReducer = (
  state: DatabaseState,
  action: DatabaseAction
): DatabaseState => {
  let nextState: DatabaseState;

  switch (action.type) {
    case databaseActions.SET_DB:
      nextState = { ...state, db: action.payload };
      break;
    case databaseActions.SET_DISABLED:
      nextState = { ...state, disabled: action.payload };
      break;
    case databaseActions.SET_ERROR:
      return { ...state, error: action.payload };
    case databaseActions.SET_SHOW_POPUP:
      return { ...state, showPopup: action.payload };
    case databaseActions.SET_IS_TAB_ACTIVE:
      nextState = { ...state, isTabActive: action.payload };
      break;
    case databaseActions.SET_IS_INITIALIZING:
      return { ...state, isInitializing: action.payload };
    case databaseActions.SET_HASHING_DISABLED:
      return { ...state, hashingDisabled: action.payload };
    case databaseActions.RESET_STATE:
      return initialDatabaseState;
    case databaseActions.SET_MULTIPLE: {
      nextState = { ...state, ...action.payload };
      break;
    }
    default:
      return state;
  }

  nextState.canWrite = computeCanWrite(nextState);
  return nextState;
};
